module.exports = __webpack_public_path__ + "img/talent2.5ddf73df.jpg";